<div class="container-box checkout-page">
	<h1 *ngIf="displayFlag">Checkout</h1>
	<app-stepindicator [stepIndicators]="steps" [sessionName]="stepSessionName"></app-stepindicator>
	<router-outlet></router-outlet>
</div>

